import React from 'react';
import { Box, IconButton, Menu, styled, Tooltip, Link } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/EditOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import Resignation from './resignation';
import ExportPdf from './exportPdf';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router';

const StyledBox = styled(Box)(
    ({ theme: { spacing, palette, typography, shape } }) => ({
        display: 'flex',
        flexDirection: 'column',
        padding: spacing(2),
        gap: spacing(2)
    })
);

export default function ActionList({ row = {}, handleClick }) {
    const [anchorEl, setAnchorEl] = React.useState({});
    const navigate = useNavigate();

    const { email: id } = row;

    const handleMenuClick = (name, value) => {
        setAnchorEl((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleClose = (name) => {
        setAnchorEl((prevState) => ({
            ...prevState,
            [name]: null
        }));
    };

    const open = function (name) {
        return Boolean(anchorEl[name]);
    };

    const handleView = (row) => {
        navigate(`/profile?id=${row?.email}`);
    };

    const handleManage = (row) => {
        navigate(`/manage/${row?.email}`, { state: row });
    };

    const handleEdit = (row) => {
        navigate(`/employee-list/${row?.email?.split('@')[0]}`, { state: row });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end'
            }}
        >
            <Tooltip title='View' placement='top'>
                <Link
                    href={`/profile?id=${row?.email}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        // Handle normal click (not Ctrl/Cmd+click)
                        if (!e.ctrlKey && !e.metaKey) {
                            e.preventDefault();
                            handleView(row);
                        }
                    }}
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        color: 'inherit',
                        textDecoration: 'none',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        },
                        '&:focus': {
                            outline: 'none',
                            backgroundColor: 'rgba(0, 0, 0, 0.12)'
                        }
                    }}
                >
                    <VisibilityIcon />
                </Link>
            </Tooltip>

            <Tooltip title='More' placement='top'>
                <IconButton
                    id={id}
                    aria-controls={open(id) ? id : undefined}
                    aria-haspopup='true'
                    aria-expanded={open(id) ? 'true' : undefined}
                    onClick={(event) => {
                        event.stopPropagation();
                        handleMenuClick(id, event.currentTarget);
                    }}
                >
                    <MoreVert />
                </IconButton>
            </Tooltip>

            <Menu
                id={id}
                anchorEl={anchorEl[id]}
                open={open(id)}
                onClose={() => handleClose(id)}
                MenuListProps={{
                    'aria-labelledby': `basic-button${id}`
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <StyledBox>
                    <Link
                        href={`/manage/${row?.email}`}
                        onClick={(e) => {
                            // Handle normal click (not Ctrl/Cmd+click)
                            if (!e.ctrlKey && !e.metaKey) {
                                e.preventDefault();
                                handleManage(row);
                            }
                        }}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            width: '100%',
                            height: '32px',
                            padding: '8px 12px',
                            border: '1px solid',
                            borderColor: 'primary.main',
                            borderRadius: '4px',
                            color: 'primary.main',
                            textDecoration: 'none',
                            fontSize: '13px',
                            fontWeight: 400,
                            cursor: 'pointer',
                            pl: 3,
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                backgroundColor: 'rgba(225, 67, 0, 0.1)',
                                textDecoration: 'none',
                                borderColor: 'rgb(225, 67, 0)',
                                color: 'rgb(225, 67, 0)'
                            },
                            '&:focus': {
                                outline: 'none',
                                backgroundColor: 'rgba(225, 67, 0, 0.1)'
                            }
                        }}
                    >
                        <SettingsIcon
                            color='primary'
                            sx={{ marginRight: 1, fontSize: '18px' }}
                        />
                        Manage
                    </Link>

                    <Link
                        href={`/employee-list/${row?.email?.split('@')[0]}`}
                        onClick={(e) => {
                            // Handle normal click (not Ctrl/Cmd+click)
                            if (!e.ctrlKey && !e.metaKey) {
                                e.preventDefault();
                                handleEdit(row);
                            }
                        }}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            width: '100%',
                            height: '32px',
                            padding: '8px 12px',
                            border: '1px solid',
                            borderColor: 'primary.main',
                            borderRadius: '4px',
                            color: 'primary.main',
                            textDecoration: 'none',
                            fontSize: '13px',
                            fontWeight: 400,
                            cursor: 'pointer',
                            pl: 3,
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                backgroundColor: 'rgba(225, 67, 0, 0.1)',
                                textDecoration: 'none',
                                borderColor: 'rgb(225, 67, 0)',
                                color: 'rgb(225, 67, 0)'
                            },
                            '&:focus': {
                                outline: 'none',
                                backgroundColor: 'rgba(225, 67, 0, 0.1)'
                            }
                        }}
                    >
                        <EditIcon
                            color='primary'
                            sx={{ marginRight: 1, fontSize: '18px' }}
                        />
                        Edit
                    </Link>

                    <ExportPdf row={row} />

                    {!row.resignationDate && <Resignation row={row} />}
                </StyledBox>
            </Menu>
        </Box>
    );
}
